import React from 'react';
import { AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PATHS from 'lib/navigation/paths';
import Typography500 from 'views/common/components/UI/Typography500';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import { ERClubBadge } from 'views/rebranded-module/location-module/LocationsViewV2/components';
import useAccordionControl from 'views/rebranded-module/location-module/LocationsViewV2/hooks/useAccordionContol';
import StyledAccordion from 'views/rebranded-module/location-module/LocationsViewV2/components/LocationsAccordion/LocationsAccordion.styles';

const LocationsAccordion = (props) => {
  const {
    market,
    membershipEnabled,
    isSearching,
    defaultVehicleType,
    content,
  } = props;

  const [expanded, handleAccordionChange] = useAccordionControl(isSearching);

  return (
    <StyledAccordion
      className="locationAccordion"
      square
      expanded={expanded}
      onChange={handleAccordionChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="LAsummary">
        <NavigatorLink
          href={
            market.geography_slug
              ? PATHS.geoSlug([defaultVehicleType.slug, market.geography_slug])
              : PATHS.locationSlug(market.slug)
          }
          key={market.id}>
          <Typography500>{market.name}</Typography500>
        </NavigatorLink>
      </AccordionSummary>
      <AccordionDetails>
        {market.locations.map((location) => (
          <NavigatorLink
            href={PATHS.locationSlug(location.slug)}
            key={location.id}
            data-testid={`locations-directory-link-${encodeURIComponent(
              location.name,
            )}`}>
            <Typography
              variant="body2"
              component="p"
              className="childLocation"
              mb={0.5}>
              {location.name}
              {' '}
              {location.membership && membershipEnabled && (
                <ERClubBadge content={content} />
              )}
            </Typography>
          </NavigatorLink>
        ))}
      </AccordionDetails>
    </StyledAccordion>
  );
};

export { LocationsAccordion };
